import { FC } from "react";

import {
  IProductionFiltersMetadata,
  IProductionStateLogData,
} from "@ryde/shared";

import { ProductionLogsStatsTabsMetricsCache } from "./production-logs.stats.tabs.metrics-cache";
import { ProductionLogsStatsTabsMetricsFilters } from "./production-logs.stats.tabs.metrics-filters";
import { ProductionLogsStatsTabsMetricsMap } from "./production-logs.stats.tabs.metrics-map";
import { ProductionLogsStatsTabsMetricsStats } from "./production-logs.stats.tabs.metrics-stats";
import { ProductionLogsStatsTabsMetricsVersions } from "./production-logs.stats.tabs.metrics-versions";

interface IProductionLogsStatsTabsMetrics {
  state?: IProductionStateLogData;
  productionFilters?: IProductionFiltersMetadata;
}

export const ProductionLogsStatsTabsMetrics: FC<
  IProductionLogsStatsTabsMetrics
> = ({ state, productionFilters }) => {
  return (
    <div className="log__stats-tab-panel">
      <ProductionLogsStatsTabsMetricsVersions state={state} />
      <ProductionLogsStatsTabsMetricsStats state={state} />
      <ProductionLogsStatsTabsMetricsMap metrics={state?.metrics} />
      <ProductionLogsStatsTabsMetricsCache metrics={state?.metrics} />
      <ProductionLogsStatsTabsMetricsFilters
        state={state}
        productionFilters={productionFilters}
      />
    </div>
  );
};
